export const POST_PAGE_SIZE = 5;
export const POST_VOTES_THRESHOLD = -10;
